import React from "react";
import ReactGoogleSlides from "react-google-slides";
import _ from "lodash";

const Slides = ({ active_slide, handle, FullScreen, hero_url }) => {
  return (
    <div className="slides">
      <FullScreen handle={handle}>
        <ReactGoogleSlides
          // width="90vw"
          // height="90vh"
          slidesLink={hero_url}
          showControls={false}
          position={active_slide}
        />
      </FullScreen>
    </div>
  );
};
export default Slides;
